import { createElement } from '../../adapters/dom';

export function formatRemainingMs(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export interface CreateCountdownElementOptions {
  label?: string;
  initialMs?: number;
  className?: string;
}

export function createCountdownElement(
  options: CreateCountdownElementOptions = {}
): {
  element: HTMLDivElement;
  valueElement: HTMLSpanElement;
  setRemainingMs: (remainingMs: number) => void;
} {
  const wrapper = createElement('div', {
    className: options.className ?? 'cpw-countdown'
  }) as HTMLDivElement;

  const label = createElement('span', {
    className: 'cpw-countdown-label',
    textContent: options.label ?? 'Осталось времени'
  });

  const valueElement = createElement('span', {
    className: 'cpw-countdown-value',
    textContent: formatRemainingMs(options.initialMs ?? 0)
  }) as HTMLSpanElement;

  wrapper.append(label, valueElement);

  return {
    element: wrapper,
    valueElement,
    setRemainingMs(remainingMs: number) {
      valueElement.textContent = formatRemainingMs(remainingMs);
    }
  };
}